import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { labelRequire } from 'Components/Common/Form/FormLabel';
import CPDateRangePicker, {
  CPDateRangePickerTypes,
} from 'Components/Common/NewDatePicker/DateRangePicker';
import { ColSpec } from 'Components/Common/Form/form';

interface FormGroupDateRangeProps extends CPDateRangePickerTypes {
  label?: string;
  subLabel?: string;
  classForm?: string;
  colClass?: string;
  labelMd?: ColSpec;
  colMd: ColSpec;
}

export default function CpFormGroupDateRange(props: FormGroupDateRangeProps): JSX.Element {
  const {
    label,
    subLabel,
    classForm,
    colClass,
    labelMd,
    colMd,
    placeholderStart,
    placeholderEnd,
    onChangeStartDate,
    onChangeEndDate,
    startDate,
    endDate,
    errorStartDate,
    errorEndDate,
    showTimeSelect = false,
    endDateDisabled = false,
    startDateDisabled = false,
    dateFormat,
    maxStartDate,
    minStartDate,
    minEndDate,
    maxEndDate,
  } = props;

  return (
    <Form.Group as={Row} className={`mb-3 ${classForm}`}>
      {label ? (
        <Form.Label column md={labelMd}>
          {labelRequire(label ?? '')}
          {<p className="fs-12">{subLabel}</p>}
        </Form.Label>
      ) : (
        ''
      )}
      <Col md={colMd} className={colClass}>
        <CPDateRangePicker
          dateFormat={dateFormat}
          startDate={startDate}
          endDate={endDate}
          errorStartDate={errorStartDate}
          errorEndDate={errorEndDate}
          placeholderStart={placeholderStart}
          placeholderEnd={placeholderEnd}
          onChangeStartDate={onChangeStartDate}
          onChangeEndDate={onChangeEndDate}
          showTimeSelect={showTimeSelect}
          startDateDisabled={startDateDisabled}
          endDateDisabled={endDateDisabled}
          minStartDate={minStartDate}
          maxStartDate={maxStartDate}
          minEndDate={minEndDate}
          maxEndDate={maxEndDate}
        />
      </Col>
    </Form.Group>
  );
}
